export const FETCH_ASSESSMENTS = "FETCH_ASSESSMENTS";
export const FETCH_ASSESSMENTS_SUCCESS = "FETCH_ASSESSMENTS_SUCCESS";
export const FETCH_ASSESSMENTS_FAILURE = "FETCH_ASSESSMENTS_FAILURE";

export const FETCH_ASSESSMENT = "FETCH_ASSESSMENT";
export const FETCH_ASSESSMENT_SUCCESS = "FETCH_ASSESSMENT_SUCCESS";
export const FETCH_ASSESSMENT_FAILURE = "FETCH_ASSESSMENT_FAILURE";

export const DELETE_ASSESSMENT = "DELETE_ASSESSMENT";
export const DELETE_ASSESSMENT_SUCCESS = "DELETE_ASSESSMENT_SUCCESS";
export const DELETE_ASSESSMENT_FAILURE = "DELETE_ASSESSMENT_FAILURE";

export const COUNT_ASSESSMENTS = "COUNT_ASSESSMENTS";
export const COUNT_ASSESSMENTS_SUCCESS = "COUNT_ASSESSMENTS_SUCCESS";
export const COUNT_ASSESSMENTS_FAILURE = "COUNT_ASSESSMENTS_FAILURE";

export const CREATE_ASSESSMENT = "CREATE_ASSESSMENT";
export const CREATE_ASSESSMENT_SUCCESS = "CREATE_ASSESSMENT_SUCCESS";
export const CREATE_ASSESSMENT_FAILURE = "CREATE_ASSESSMENT_FAILURE";
